"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enforceKey = enforceKey;
exports.enforcePortalId = enforcePortalId;

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

function enforceKey(key) {
  (0, _invariant.default)(typeof key === 'string' && key.length > 0, 'SettingsAPI: expected key to be a non-empty string but got "%s"', key);
}

function enforcePortalId(portalId) {
  (0, _invariant.default)(typeof portalId === 'number', 'SettingsAPI: expected portalId to be a number but got %s', portalId);
}